export const MODULE_PREFIX = 'videos';
